export class ScrollToggle {
	constructor(element) {
        console.log('ScrollToggle : constructor')
		this.container = element
		this.toggles = this.container.querySelectorAll(".scroll-block__nav-btn")
		this.list = this.container.querySelector(".scroll-block__list")
		this.listItems = this.list.querySelectorAll(".scroll-block__item")
		this.scrollValue = 0
	}
	init() {
		this.toggles.forEach(toggle => {
			toggle.addEventListener("mousedown", (e) => {
				this.move(e.target)
			})
			toggle.addEventListener("mouseup", (e) => {
				this.stop()
			})
		})
	}
	move(target) {
		if (target.classList.contains("scroll-block__nav-btn--right")) {
			this.interval = setInterval(() => {
				this.list.scrollLeft += 2
			}, 1)
		} else {
			this.interval = setInterval(() => {
				this.list.ScrollLeft = this.scrollValue
				this.list.scrollLeft -= 2
			}, 1)
		}
	}
	stop() {
		if (this.list.scrollLeft > 0) {
			this.scrollValue = this.list.scrollLeft
		}
		clearInterval(this.interval)
	}
}